import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import Heading from 'LuxKit/Typography/Heading'
import List from 'components/Common/List'

type Props = {
  packageInclusions: Array<string>
}

function AccommodationPackageInclusions({ packageInclusions }: Props) {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: 'hnQFxuD7xgWuh7cb4MwJ',
    defaultMessage: 'Inclusions valid for, based on package purchased',
    description: 'Heading for the package inclusions section within the guest policy area of the room details modal.',
  })

  return (
    <>
      <Heading variant="heading6" as="h4">{heading}</Heading>
      <List>
        {packageInclusions.map((inclusion) => (
          <BodyText key={inclusion} as="li" variant="medium">
            {inclusion}
          </BodyText>
        ))}
      </List>
    </>
  )
}

export default AccommodationPackageInclusions
